module.exports = __webpack_public_path__ + "static/ionicons-19e65b89cee273a249fba4c09b951b74.eot";